const scrollClicker = (e, nodes, link) => {
	if (e?.button === 1 && link) {
		if (!nodes) {
			window?.open(link, "_blank");
		}
	}
};

export default scrollClicker;
